const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

function apiUrl(path) {
  const base = API_BASE.replace(/\/$/, "");
  const suffix = path.startsWith("/") ? path : `/${path}`;
  return `${base}${suffix}`;
}

export async function parseApiError(response) {
  let body = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  const message = body?.message;
  if (Array.isArray(message)) return message.join(", ");
  if (typeof message === "string" && message) return message;
  return `Request failed (${response.status})`;
}

export async function loginRequest(email, password) {
  const response = await fetch(apiUrl("/auth/login"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!response.ok) {
    const err = new Error(await parseApiError(response));
    err.status = response.status;
    throw err;
  }
  return response.json();
}

export async function refreshRequest(refreshToken) {
  const response = await fetch(apiUrl("/auth/refresh"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refreshToken }),
  });
  if (!response.ok) {
    const err = new Error(await parseApiError(response));
    err.status = response.status;
    throw err;
  }
  return response.json();
}

export async function meRequest(accessToken) {
  const response = await fetch(apiUrl("/auth/me"), {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!response.ok) {
    const err = new Error(await parseApiError(response));
    err.status = response.status;
    throw err;
  }
  return response.json();
}

export async function logoutRequest(accessToken) {
  const response = await fetch(apiUrl("/auth/logout"), {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!response.ok) {
    const err = new Error(await parseApiError(response));
    err.status = response.status;
    throw err;
  }
  return response.json();
}

export function isApiConfigured() {
  return Boolean(API_BASE);
}
